import { Component } from '@angular/core';
import { SkyModalInstance } from '../modal';
import { SkyTextExpandModalContext } from './text-expand-modal-context';


export class SkyTextExpandModalComponent {
  constructor(
    public context: SkyTextExpandModalContext,
    public instance: SkyModalInstance
  ) {}

  public close() {
    this.instance.close();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-text-expand-modal',
  template: `<sky-modal>
  <sky-modal-header>{{context.header}}</sky-modal-header>
  <sky-modal-content class="sky-text-expand-modal-content">{{context.text}}</sky-modal-content>
  <sky-modal-footer>
    <button
      class="sky-btn sky-btn-link"
      (click)="close()">{{'text_expand_close_text' | skyResources}}</button>
  </sky-modal-footer>
</sky-modal>
`,
  styles: [`.sky-text-expand-ellipsis {
  letter-spacing: 2px;
  white-space: nowrap;
  margin-right: 3px;
}

.sky-text-expand-space {
  white-space: normal;
}

.sky-text-expand-see-more {
  white-space: nowrap;
}

.sky-text-expand-text {
  margin: 0;
  white-space: pre-wrap;
}

.sky-text-expand-container {
  word-break: break-word;
  word-wrap: break-word;
  overflow: hidden;
  height: auto;
  transition: max-height 250ms;
}

.sky-text-expand-modal-content {
  white-space: pre-line;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyTextExpandModalContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
